<script>
    import GPApp from '../gp-app.svelte';
    import GPMenuFMG from './gp-menu-fmg.svelte';
    import {app, overwriteOnlineName, unsavedChanges} from "../gp.js";

</script>

<svelte:head>
    <title>{($overwriteOnlineName==="" ? "GardenPuzzzle" : $overwriteOnlineName + " - GardenPuzzzle") + ($unsavedChanges ? " *" : "")}</title>
</svelte:head>
<GPApp bind:this={$app} appType="FMG">
    <span slot="headerLeft">
        <div class="headerLeft">
            <a class="gardenpuzzleUrl" href="/">
                <img src="img/gpLogo.svg"/>
            </a>
        </div>
    </span>
    <span slot="menu">
        <GPMenuFMG/>
    </span>
</GPApp>